import PropertyPathHelper from '../../../../utils/PropertyPathHelper';

const SoldPropertyIdMixin = {
  computed: {
    soldPropertyId() {
      return PropertyPathHelper.parseIdFromParam(this.$route.params.id);
    },
  },
};

export default SoldPropertyIdMixin;
